import React from 'react';
import { useSelector } from 'react-redux';
import { numberWithCommas } from '../../utils/functions';

export default function Annotation() {
  const partyData = useSelector((state) => state.data.partyData);
  const address = useSelector((state) => state.data.address);
  const geoPP = useSelector((state) => state.data.geoPP);
  const totalVotes = useSelector((state) => state.data.totalVotes);
  const dataRadius = useSelector((state) => state.data.dataRadius);

  /*
  function bubbleQuestion(perc) {
    if (perc > 0.8) {
      return (
        <p>You may live in a political bubble! which is rare in Australia.</p>
      );
    }
    return (
      <p>
        You <strong>do not</strong> live in a political bubble.
      </p>
    );
  }
  */

  function getNumberOfIndepndents() {
    const inde = dataRadius.filter((obj) => {
      return obj.pn === 'Independent';
    });
    if (inde && inde.length > 0) {
      const idList = inde.map((obj) => {
        return obj.bubID;
      });
      const unIdList = Array.from(new Set(idList));
      return unIdList.length;
    }
    return '0';
  }

  function getAnnotation() {
    if (partyData.length > 0) {
      return (
        <div className="snippet">
          <h4>Results for {address}</h4>
          {/* bubbleQuestion(partyData[0].perc) */}
          <p>
            In a <strong>2</strong> kilometre radius from your address, there
            were <strong>{numberWithCommas(totalVotes)}</strong> votes cast at{' '}
            <strong>{geoPP.features.length} </strong>
            separate polling locations at the 2019 federal election, as shown on
            the map above.
          </p>
          <p>
            Votes were cast for <strong>{partyData.length - 1}</strong> parties
            and <strong>{getNumberOfIndepndents()}</strong> independent
            candidates, with <strong>{partyData[0].p}</strong> candidates
            receiving the most first preference votes at{' '}
            <strong>{Math.round(partyData[0].perc * 10000) / 100}%</strong>,
            followed by <strong>{partyData[1].p}</strong> candidates who
            received{' '}
            <strong>{Math.round(partyData[1].perc * 10000) / 100}%</strong>.
          </p>
          {/* 
          <p>
            The bubble chart and table below depict a detailed snapshot of your
            area. The bubble chart shows all first preference votes for
            candidates by polling location. The table displays the overall
            results by party. Both charts include the often well-represented
            &apos;Informal&apos; ballots.
          </p>
          */}
        </div>
      );
    }
    return <div />;
  }

  return <section className="mid-col">{getAnnotation()}</section>;
}
